export class AiBatchReviewRecordChange {
  label: string;
  from: string;
  to: string;

  constructor(label: string, from: string, to: string) {
    this.label = label;
    this.from = from;
    this.to = to;
  }
}
